import React from 'react';
import PropTypes from 'prop-types';

const DownloadIcon = ({ size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${size} ${size}`}
      width={size}
      height={size}
    >
      <g transform="translate(-397 -369)">
        <rect fill="none" width="21" height="21" transform="translate(397 369)" />
        <g transform="translate(397 369.2)">
          <path
            fill="hsl(347, 99%, 60%)"
            d="M20.3,13.8a1.136,1.136,0,0,0-.8-.3h0a1.11,1.11,0,0,0-1.1,1.1v3.8H2.2V14.6a1.11,1.11,0,0,0-1.1-1.1A1.11,1.11,0,0,0,0,14.6v4.9a1.135,1.135,0,0,0,.3.8,1.135,1.135,0,0,0,.8.3H19.6a1.11,1.11,0,0,0,1.1-1.1V14.6A1.506,1.506,0,0,0,20.3,13.8Z"
          />
          <path
            fill="hsl(347, 99%, 60%)"
            d="M9.8,15l.2.2a1.09,1.09,0,0,0,1.1-.2L16,9.8a1.061,1.061,0,0,0-1.5-1.5l-3,3.2V1.1A1.11,1.11,0,0,0,10.4,0,1.135,1.135,0,0,0,9.2,1.1V11.4L6.3,8.2a2.01,2.01,0,0,0-.8-.4,1.08,1.08,0,0,0-.7.3,1.116,1.116,0,0,0-.1,1.6Z"
          />
        </g>
      </g>
    </svg>
  );
};

DownloadIcon.propTypes = {
  size: PropTypes.number,
};

export default DownloadIcon;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/press/DownloadIcon.js